/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AverageHouseCostChangeDto, DashboardAverageItem } from '@gh/builder-shared-data';

export type AverageHouseCostChange = AverageHouseCostChangeDto;
export const averageHouseCostChangeDtoFromDto = (dto: AverageHouseCostChangeDto): DashboardAverageItem[] => dto ? [
  {
    value: dto.change,
    label: '',
    isMain: true,
    format: 'Percents_2',
    suffix: '%',
    arrowDown: -1 === Math.sign(dto.change),
    arrowUp: 1 === Math.sign(dto.change),
  },
  {
    label: 'lbl_current_average_houses_cost',
    value: dto.houseCostAvgCurr,
    isMain: false,
    format: 'Price',
  },
  {
    label: 'lbl_number_of_hp',
    value: dto.houseCountCurr,
    isMain: false,
    format: 'Quantity',
  },
  {
    label: 'lbl_prior_average_houses_cost',
    value: dto.houseCostAvgPrior,
    isMain: false,
    format: 'Price',
  },
  {
    label: 'lbl_number_of_hp',
    value: dto.houseCountPrior,
    isMain: false,
    format: 'Quantity',
  },
] : [];
